import { createTheme } from '@mui/material';

import {
  accentColor,
  // inactiveGrey,
  // lightGrey,
  primaryColor,
  secondaryColor,
  successGreen,
} from './colors';

/**
 * For customizing, please refer below links
 * https://mui.com/material-ui/customization/theming/
 *
 * or check this article
 * https://muhimasri.com/blogs/how-to-customize-theme-and-colors-in-material-ui/
 */
export const muiTheme = createTheme({
  palette: {
    primary: {
      main: primaryColor,
    },
    secondary: {
      main: secondaryColor,
    },

    error: {
      main: '#FF4E4E',
    },
    success: {
      main: successGreen,
    },
    background: {
      default: '#FAFAFA',
    },

    divider: '#DDDDDD',
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 640,
      md: 768,
      lg: 1024,
      xl: 1200,
    },
  },
  typography: {
    fontFamily: 'Inter,Roboto,sans-serif',
  },
  components: {
    MuiPopover: {
      styleOverrides: {
        paper: {
          borderRadius: 2,
          padding: 0,
        },
      },
    },
    MuiList: {
      styleOverrides: {
        root: {
          padding: 0,
        },
      },
    },
    MuiLink: {
      defaultProps: {
        fontWeight: 600,
        color: accentColor,
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: '#EEEEEE',
        },
      },
    },
    MuiInputLabel: {
      defaultProps: {
        size: 'small',
      },
    },
    MuiOutlinedInput: {
      defaultProps: {
        size: 'small',
      },
      styleOverrides: {
        root: {
          fontWeight: 500,
          borderRadius: 8,
        },
      },
    },
    MuiTypography: {
      variants: [
        {
          props: { variant: 'h5' },
          style: {
            fontWeight: '600',
            fontSize: 24,
          },
        },
        {
          props: { variant: 'h6' },
          style: {
            fontWeight: '600',
          },
        },
      ],
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          boxShadow:
            '0px 1px 6px rgba(76, 78, 100, 0.1), 0px 1px 2px rgba(76, 78, 100, 0.1)',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          borderWidth: 2,
          borderColor: primaryColor,
          padding: '9px 22px',
          height: 42,
          ':hover': {
            borderWidth: 2,
          },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          '&.Mui-disabled': {
            backgroundColor: '#A0A0A01A',
          },
        },
      },
    },
  },
  spacing: (factor: number) => `${0.25 * factor}rem`,
});

export default muiTheme;
